var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.listLoading,
          expression: "listLoading",
        },
      ],
      staticStyle: { width: "100%" },
      attrs: {
        id: "clients-table",
        data: _vm.list,
        fit: "",
        "highlight-current-row": "",
      },
    },
    [
      _c("el-table-column", {
        attrs: {
          width: "80",
          align: "center",
          label: "ID",
          sortable: "",
          "sort-method": _vm.sortClientId,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var row = ref.row
              return [_c("span", [_vm._v(_vm._s(row.clientId))])]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          "class-name": "truncate",
          "min-width": "120px",
          label: "Name",
          sortable: "",
          "sort-method": _vm.sortName,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var row = ref.row
              return [_vm._v(" " + _vm._s(row.name) + " ")]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          "class-name": "truncate",
          "min-width": "80px",
          align: "left",
          label: "Company",
          sortable: "",
          "sort-method": _vm.sortCompany,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var row = ref.row
              return [_vm._v(" " + _vm._s(row.company) + " ")]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          "class-name": "truncate",
          "min-width": "80px",
          align: "left",
          label: "Phone",
          sortable: "",
          "sort-method": _vm.sortPhone,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var row = ref.row
              return [_vm._v(" " + _vm._s(row.phone) + " ")]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { width: "200px", align: "left", label: "Image Path" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var row = ref.row
              return [_vm._v(" " + _vm._s(row.imagePath) + " ")]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          label: "Actions",
          width: "110",
          fixed: "right",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "router-link",
                  { attrs: { to: "/clients/edit/" + row.clientId } },
                  [
                    _c("el-button", {
                      attrs: {
                        type: "primary",
                        size: "mini",
                        icon: "el-icon-edit",
                        circle: "",
                        plain: "",
                      },
                    }),
                  ],
                  1
                ),
                _c("el-button", {
                  staticStyle: { "margin-left": "5px" },
                  attrs: {
                    type: "warning",
                    size: "mini",
                    icon: "el-icon-delete",
                    circle: "",
                    plain: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleDelete(row.clientId)
                    },
                  },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }